import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';

const sdo = {
  namespace: sdoNs.STUDENT_STATUS_LIST,
  mutations: {
    init() {
      return {
        collapsesByStatus: {},
      };
    },
    toggleCollapse(_subState, _payload) {
      const collapsesByStatus = {..._subState.collapsesByStatus};
      collapsesByStatus[_payload] = !collapsesByStatus[_payload];
      return {
        ..._subState,
        collapsesByStatus
      };
    },
  },
  decorators: [
  ]
};

storeInstance.addState(sdo);
